export const generateSizeRange = (
  min: number,
  max: number,
  step: number = 0.5,
): number[] => {
  return Array.from(
    { length: (max - min) / step + 1 },
    (_, i) => min + i * step,
  );
};
